export const locale = {
  lang: "ar",
  data: {
    Global: {
      rTicket: "بحث التذاكر",
      ncs: "لا يسمح بأي أحرف خاصة",
      vSuj: "الرجاء اختيار الموضوع",
      rec: "مطالبة",
      di: "طلب معلومات",
      rem: "شكرًا",
      av: "رأي",
      success: "نجاح",
      info: "معلومة",
      err: "خطأ",
      tousS: "جميع الخدمات",
      tnd: "دينار تونسي",
      bonus: "مكافأة",
      dt: " دت",
      boutonpd: "المزيد من التفاصيل",
      opp: "نقل المشغّل",
      oo: "اوريدو",
      tt: "إتصالات تونس",
      or: "اورنج",
      valider: "تأكيد",
      org: "هيئة",
      ref: "المرجع",
      montant: "المبلغ",
      mp: "المبلغ المدفوع",
      env: "أرسل",
      max: "الحد الأقصى",
      conf: "تأكيد",
      renv: "إعادة الإرسال",
      ann: "إلغاء",
      retourcnx: "العودة إلى صفحة تسجيل الدخول",
      retour: "عودة",
      continuer: "استمرار",
      passer: "تخطي هذه الخطوة",
      suiv: "التالي",
      payer: "دفع",
      rp: "إيصال الدفع",
      rt: "إيصال الحوالة",
      pnv: "الدفع عن طريق بطاقة جديدة",
      mdp: "طريقة الدفع",
      date: "التاريخ",
      it: "رقم المعاملة",
      dateOp: "تاريخ العملية",
      etat: "الحالة",
      ea: "في الانتظار",
      bonusg: "المكافأة المكتسبة",
      pfc: "النقاط الولاء المجمعة",
      sold: "الرصيد",
      msg: "يتم مكافأة عملية الشراء الخاصة بك، تشكرك spw على وفائك.",
      astuce: "إقتراحات SPW!",
      rEmailActif: "العودة لصفحة الرئيسية",
      supportADisposition: "عند الحاجة، خدمة العملاء  تحت تصرفك",
      desWallet1:
        "المحفظة هي محفظتك الافتراضية التي تتيح لك إدارة رصيد حسابك spw عبر الإنترنت",
      desWallet2: "أرسل الأموال واستلمها بسهولة وادفع مقابل جميع الخدمات باستخدام محفظة spw",
      pts: "نقاط",
      confirm: "تأكيد",
      confdemande: "قم بتأكيد طلبك",
      resOp: "نتيجة العملية",
      vRes: "نتيجة العملية",
      choixMP: "اختر طريقة الدفع",
      addBenf: "إضافة المستفيد",
      avis: "شارك رأيك",
      wlc: "أنت متصل جيدًا بـ spw🎉 ، مرحبًا 👋",
      tapmsg: "الرجاء كتابة رسالتك",
      pin: "تمت إضافة رقم التعريف الشخصي بنجاح",
      msgcode: "الرجاء إدخال رمز واحد على الأقل أو تخطي هذه الخطوة",
      mconf: "👋 لقد قمت بالفعل بتأكيد بريدك الإلكتروني",
      tconf: "👋 لقد قمت بالفعل بتأكيد رقم هاتفك",
      imgmsg: "نقبل الامتدادات (jpg و png و jpeg) ويجب أن يكون الحجم أقل من 5 ميغابايت",
      paymsg: "لا يمكنك الدفع بهذه البطاقة",
      wallmsg: "لا يمكنك الدفع باستخدام Wallet",
      editmsg: "تم تغيير بنجاح",
      gcb: "تم حذف هذه البطاقة",
      rib: "RIB لا يتوافق مع أي بنك ، يرجى التحقق",
      editben: "تم تغيير المستفيد بنجاحتم تغيير المستفيد بنجاح",
      tranmsg: "أدخل الرقم والمبلغ",
      max50: "الحد الأقصى للمبلغ هو 50 د ت",
      numinv: "رقم الهاتف غير صحيح",
      wallins: "رصيدك في المحفظة غير كافٍ",
      fav: "قم بإدارة عرض خدماتك المفضلة على الصفحة الرئيسية بالضغط على النجمة",
      notif: "إشعارات",
      notif2: "غير مقروءة",
      notif3: "عرض الكل",
      notif4: "لم يتم العثور على أي إشعارات",
      param: "الإعدادات",
      faq: "FAQ",
      deco: "إغلاق",
      cb: "حساب بنكي",
      paym: "دفع التاجر",
      wsf: "محفظة spw",
      aw: "تمويل المحفظة عن طريق",
      cp: "بطاقة الدفع",
      vv: "التنزيل / التحويل",
      rev: "نقطة بيع",
      pre: "السابق",
      dastuce:
        "هل ترغب في حفظ هذه البطاقة لإجراء عملية دفع أسهل وأسرع وأكثر أمانًا في المرة القادمة؟",
      pm: "ليس الأن",
      enr: "تسجيل",
      frais: "التكاليف",
      transuc: "تمت معالجة المعاملة بنجاح",
      lcom: "اترك تعليقا",
      com: "تعليق",
      noter: "ملاحظه",
      sms: "رسالة قصيرة",
      codeenv: "أدخل الرمز المرسل إلى",
      codeenva: "تم إرسال الرمز إلى",
      codeenvnum: "تم إرسال الرمز إلى الرقم",
      codee: "أدخل الرمز المرسل إليك",
      mvs: "حركة مبلغ الإئتمان",
      dd: "تاريخ البداية",
      df: "تاريخ الانتهاء",
      nomv: "لا يوجد أي حركة لمبلغ الإئتمان",
      merci: "شكرا لك على عملية الشراء",
      ta: "تحويل الأموال",
      rbank: "هوية بيان البنك",
      nvs: "الرصيد الجديد",
      infoB1: "يمكنك الاستفادة من مكافأة spw بعد شراء أي خدمة على منصتنا",
      infoB2: "تتم إضافة مبلغ هذه المكافأة إلى رصيد المكافأة الخاص بك مباشرة بعد تأكيد الدفع",
      infoB3:
        "يمكنك بعد ذلك تحويل رصيد المكافأة الخاص بك إلى رصيد الائتمان الخاص بك والاستفادة من جميع الخدمات المتاحة.",
      infoAvoir:
        "يمثل رصيد الائتمان المبلغ المدفوع بعد السداد أو التعويض أو أي سبب آخر. ثم يسمح لك بالدفع مقابل الخدمات التي تقدمها spw",
    },
    Dash: {
      title1: "محفظتي",
      stnd: "رصيد بدينار تونسي",
      da: "أحدث تعبئة",
      dt: "أحدث تحويل",
      alim: "شحن",
      tran: "التحويل",
      tiktak: "تيك تاك",
      dTiktak: "قم بالشراء بسرعة بنقرتين مع خدمة تيك تاك الجديدة لدينا",
      boutonTiktak: "اكتشف",
      titletran: "المعاملات",
      dTran: "آخر معاملاتي",
      sfid: "حالة ولائك",
      dtbonus: "مكتسب كمكافأة",
      tsoldeavoir: "التحويل إلى الرصيد المتوفر",
      soldeav: "الرصيد المتوفر لديك",
      titlequick: "تحويل الأموال إلى محفظة spw أخرى",
      titlequick2: "إضافة المستفيدين",
      demwallet: "اطلب محفظة",
      as: "شراء على spw",
      std: "المعايير",
      pf: "نقاط الولاء",
      messolde: "أرصدتي",
      suivisolde: "تتبع الرصيد",
      sa: "الوضع الحالي",
      qt1: "الحصة المخصصة لشراء الخدمات هي",
      qt2: "د.ت يوميا",
      gservF: "إدارة الخدمات المفضلة لديك",
      notif: "إشعارات",
      sc: "مرشد الحرفاء",
      trB: "تحويل المكافأة الى الرصيد الموجود",
    },
    tiktak: {
      tiktak: "تيك تاك",
      title: "يتم الدفع مباشرة برصيد محفظة spw الخاصة بك: انقر على الدفع.",
      title1: "شحن الهاتف عن طريق التحويل المباشر",
      title2: " شحن الهاتف عن طريق بطاقة الشحن",
      title3: "دفع الفواتير",
      msg1: "ستقوم بتحويل مباشر بقيمة",
      msg2: "دينار تونسي إلى الرقم",
      payer: "دفع",
      recu: "إيصال الدفع",
      rautre: "إعادة تحميل رقم آخر",
      msg3: "نجاح العملية",
      msg4: "انقر على الإيصال لرؤية رمز إعادة التحميل الخاص بك",
      msg5: "سوف تشتري بطاقة شحن هاتف",
      msg6: "بقيمة",
      tdtitle: "تحويل سريع",
      msg7: "نجاح عملية شحن الهاتف",
    },
    verf: {
      title: "قم بتأكيد عنوان بريدك الإلكتروني ورقم هاتفك للتحقق من حسابك",
      confM: "تأكيد بريدي الإلكتروني",
      confM2: "تم تأكيد البريد الإلكتروني",
      confT: "التحقق من صحة  رقم  هاتفي",
      confT2: "الهاتف الموثق",
      verCompte: "تحقق من حسابي",
      d1: "أدخل الرمز المستلم في",
      contenu1: "تغيير البريد الإلكتروني الخاص بي",
      contenu2: "رقم الهاتف الجديد",
      desVer: "تحقق من حسابي وأنشئ محفظتي الأولى",
      des: "تحقق من هويتك واستفد من الوصول غير المحدود إلى جميع الخدمات على spw",
      cj: "دخول الأموال / يوم",
      mcj: "عمليات خروج الأموال / يوم",
      ocj: "عمليات دخول الأموال / يوم",
      o: "عمليات",
      mocj: "الحد الأقصى لعمليات خروج الأموال / يوم",
      sw: "رصيد المحفظة",
      v: "حساب تم التحقق منه",
      enc: "يتم معالجتها",
      rf: "املأ النموذج عبر الإنترنت",
      oui: "نعم",
      non: "لا",
    },
    control: {
      champobli: "اسم الخانة إلزامي",
      min6: "6 أرقام كحد أدنى",
      min6c: "الحد الأدنى 6 أحرف",
      max16: "الحد الأقصى 16",
      invFormat: "تنسيق غير صحيح",
      min2: "الحد الأدنى 2!",
      max2: "الحد الأقصى 2!",
      montantinc: "المبلغ غير صحيحة ",
      mailob: "البريد الالكتروني إلزامي",
      mailv: "أدخل عنوان بريد إلكتروني صحيح",
      codeinc: "رمز خاطئ",
      numinv: "رقم غير صالح",
      piniden: "يجب أن تكون الأرقام السرية  متطابقة",
      patterPrenom: "الرجاء إدخال اسم أول صالح",
      patterNom: "رجاء ادخل اسما صحيحا",
      mdp: "يجب أن تتكون كلمة المرور الخاصة بك من 8 أحرف على الأقل (مجموعة من الأرقام والأحرف وحرف MAJ و MIN واحد على الأقل)",
      mdpinv: "رمز مرور خاطئ",
      mdpidn: "يجب أن تكون كلمات المرور متطابقة",
      mode: "اختر كيفية إرسال الرمز",
      nomval: "رجاء ادخل اسما صحيحا",
      pin6: "يتكون رمز PIN من 6 أرقام",
      pininc: "PIN ليس صحيحا",
      max: "الحد الأقصى ",
      min1dt: "الحد الأدنى 1 د",
      min10dt: "الحد الأدنى 10 د",
      dd: "تاريخ البدء مطلوب",
      df: "تاريخ الانتهاء مطلوب",
      opob: "نوع العملية مطلوب",
      rib: "يتكون RIB من 20 رقمًا",
      min4: "الحد الأدنى 4 أحرف",
      min: "الحد الأدنى",
      maxi: "الحد الأقصى",
      inv: "غير صالح",
      dfsup: "يجب أن يكون تاريخ الانتهاء أكبر من تاريخ البدء",
      top: "نوع العملية",
      cinv: "رمز الارتباط غير صالح",
      c100m: "100 حرف كحد أقصى",
      mmin: "الحد الأدنى للمبلغ",
    },
    placeholder: {
      numtel: "رقم الهاتف",
      mont: "المبلغ",
      numver: "رقم الدفع",
      trVV: "قم بتنزيل إيصال الإيداع / التحويل",
      idw: "محفظة المستفيد / معرف البريد الإلكتروني",
      motiftran: "نمط التحويل",
      motiftran2: "سبب التحويل اترك رسالة للمستفيد ",
      rib: "الرقم البنكي الدولي",
      bank: "بنك",
      searchfav: "البحث المفضل",
      numfav: "رقم الهاتف",
      search: "بحث",
      cm: "رمز التاجر",
      etq: "بطاقة الأسعار",
      nmail: "بريد إلكتروني جديد ",
      cP: "رمز/ كود الرسالة النصية",
      cM: "كود/ رمز البريد الإلكتروني",
      mP: "تغيير الهاتف",
      mM: "تغيير البريد الإلكتروني",
      davis: "رأيك يهمنا. لا تتردد في إرسال توصية أو رأي أو ملاحظة أو غير ذلك.",
    },
    Connexion: {
      welcome: "مرحبًا بك في spw",
      msg1: "قم بتسجيل الدخول إلى حسابك",
      dPIN2: "أمانك هو أولويتنا ، أدخل رقم التعريف الشخصي الخاص بك",
      msg3: "جديد في spw ؟",
      msg4: "إنشاء حساب",
      pin: "رمز الحماية",
      pinoub: "نسيت رمز الحماية؟",
      cnx: "اتصال",
    },
    Inscri: {
      title: "المغامرة تبدأ هنا",
      title2: "التسجيل في spw سريع ومجاني",
      dPIN: "من أجل أمانك ، قم بتعيين رمز حماية",
      errmsg1: "لديك بالفعل حساب على spw بهذا عنوان البريد الإلكتروني.",
      errmsg2: "هذا البريد الإلكتروني قيد الاستخدام بالفعل.",
      title4: "هل لديك بالفعل حساب؟",
      title5: "تسجيل الدخول",
      title6: "أو قم بالتسجيل باستخدام",
      confpin: "تحديث  رقم التعريف الشخصي",
      condi: "شروط الاستعمال",
      condi2: "سياسة الخصوصية",
      et: "و",
      condi3: "سياسة الاسترداد",
      condi4: "بواسطة spw",
      ng: "إسم المدير",
      pg: "إسم المدير",
      nummob: "رقم الهاتف الجوال",
      numfix: "رقم الهاتف المنزلي",
      sd: "قطاع النشاط",
      fj: "الوضع القانوني",
      pp: "شخص طبيعي",
      sarl: "شركة ذات مسؤولية محدودة",
      sa: "شركة خفية الإسم",
      suarl: "SUARL",
      numi: "رقم الهوية",
      numiinv: "رقم الهوية غير صالح",
    },
    forgotPass: {
      rPW: "إعادة تعيين كلمة المرور",
      descMP: "أدخل عنوان البريد الإلكتروني ورقم الهاتف المرتبطين بحسابك spw ",
      dPW: "قم بتعيين كلمة المرور الجديدة الخاصة بك",
    },
    ResetPin: {
      rPIN: "إعادة تعيين PIN",
      dPIN3: "قم بتعيين رقم التعريف الشخصي الجديد الخاص بك",
    },
    Browsec: {
      sauv: "احفظ المتصفح",
      title: "التحقق من الهوية",
      title1: "للوصول إلى حسابك بشكل آمن، نريد التحقق من هويتك",
    },
    vPIN: {
      title: "الرقم السري",
      des: "",
    },
    Carte: {
      alimCarte: "الشحن عن طريق البطاقة",
      dAlimCarte: "اختر المبلغ والبطاقة",
      Conf: "تأكيد",
      RS: "نتيجة العملية",
      D1: "قم بتعبئة محفظتك spw ببطاقة عبر الإنترنت وبأمان",
      desAlim:
        "أدخل المبلغ واختر البطاقة التي تناسبك ، وقم بتأكيد الدفع ، وسيتم إعادة شحن محفظتك spw فورًا",
      aw: "تحميل المحفظة",
      rw: "شحن المحفظة",
      numver: "رقم الإيداع / التحويل",
      numc: "رقم الحساب",
    },
    Espece: {
      title1: "إعادة شحن المحفظة عن طريق الإيداع / التحويل",
      title2: "قائمة الوكالات",
      AE: "تحميل محفظة النقد",
      DAC: "مـِلء الاستماره ",
      Conf: "تأكيد",
      RS: "نتيجة العملية",
      D1: "ليس لديك بطاقة دفع عبر الإنترنت! هذا الحل لك",
      D2: "نقدًا من خلال حساباتنا المصرفية ، يمكنك إجراء إيداع  / تحويل لتمويل محفظة spw الخاصة بك",
    },
    popRes: {
      title: "أنك غير مخول",
      des: "",
      title2: "التحقق",
    },
    AccountSet: {
      title: "المعلومات الشخصية",
      bouton: "تحرير",
      des: "مسموح بـ JPG أو GIF أو PNG. الحد الأقصى للحجم 800 كيلو بايت",
      pmcp: "إعدادات الحساب",
      vw: "التحقق والمحفظة",
      nom: "الإسم",
      prenom: "اللقب",
      dn: "تاريخ الولادة",
      ville: "المدينة",
      modifmdp: "تغيير كلمة المرور",
      modifpin: "تغيير رقم التعريف الشخصي",
      modifmail: "تغيير البريد الإلكتروني",
      hismail: "عرض سجل البريد الإلكتروني",
      vpin: "التحقق من رقم التعريف الشخصي (PIN) مع كل معاملة",
      cc: "غلق الحساب",
      ancienpass: "كلمة المرور القديمة",
      vpass: "كلمة مرور جديدة",
      cpass: "تأكيد كلمة المرور",
      ancienpin: "رقم التعريف الشخصي القديم",
      vmpin: "رقم التعريف الشخصي الجديد",
      cpin: "تأكيد رقم التعريف الشخصي",
      ancientel: "رقم الهاتف القديم",
      vtel: "رقم الهاتف الجديد",
      mdp: "كلمة المرور",
      numide: "يجب ألا تكون الأرقام متطابقة",
      scode: "رمز الحماية",
      mdpoub: "لا تتذكر كلمة المرور ؟",
      ancienm: "البريد الإلكتروني القديم",
      hemail: "سجل تغيير البريد الإلكتروني",
      email: "البريد الإلكتروني",
      du: "تاريخ الاستخدام",
      dm: "تاريخ التعديل",
      vk: "أكمل المعلومات المنقوصة عبر هذا النموذج للحصول على محفظة SPW",
    },
    Rev: {
      title:
        "قم بشحن محفظة SPW الخاصة بك في وكلاء spw. اذهب إلى أقرب متجر واودع النقود لإعادة التحميل الفورية.",
      rev: "وكلاء",
      search: "البحث عن وكيل",
    },
    CashOut: {
      title1: "تحويل الأموال إلى محفظة spw",
      wFav: "محافظ المستفيدين المفضلة",
      tw: "تحويل الأموال إلى المحفظة",
      dtw: "مـِلء الاستماره ",
      tvw: "تحويل إلى المحفظة",
      d1: "باستخدام محفظتي ، أرسل الأموال على الفور إلى محفظة spw أخرى ، أينما كنت ومتى أريد",
      d2: "املأ النموذج ، وأكد عملية التحويل وسيتم  شحن محفظة المستلم على الفور",
      dwf: "تحويل الأموال أسهل! أضف محافظ أحبائك إلى قائمة المفضلة ",
      title3: "تحويل الأموال إلى حساب بنكي",
      title4: "حساباتي البنكية",
      d3: "طلب تحويل أموال",
      d4: "تحويل أموال آمن ومضمون إلى حسابي المصرفي! إنه التزامنا",
      mcb: "إدارة الحساب البنكي",
      addrib: "يرجى إضافة الرقم البنكي الدولي للقيام بتحويل بنكي",
      conftran: "قم بتأكيد تحويل الأموال",
      addBenf1: "أضف مستفيد إلى قائمة المفضلة",
      nombenf: "أسم المستفيد",
      confdem: "تأكيد طلب التحويل",
      addRIB: "إضافة حساب بنكي",
      desAddR2: "أدخل رقم حسابك وقم بتنزيل معرف البنك",
      dmen: "طلب تحويل الأموال",
      vb: "الهوية البنكية",
      dd: "تاريخ الطلب",
      nbenf: "إسم المستفيد",
      rbenf: "الهوية البنكية للمستفيد",
      mwall: "تغيير المستفيد",
      nomben: "إسم المستفيد",
      vnomben: "الرجاء إدخال اسم مستفيد صالح",
      img: "صورة",
      title2: "اختار الرصيد الذي تريد التحويل منه",
    },
    RechTel: {
      d1: "مع spw ! إعادة شحن هاتف بسيطة ومجزية",
      d2: "أدخل رقم الهاتف والمبلغ ، وادفع بشكل آمن ، وسيتم إعادة شحن خطك على الفور",
      gmf: "إدارة قائمة المفضلة",
      d4: "حدد بطاقة إعادة الشحن الخاصة بك من مشغل الهاتف الخاص بك ، ادفع بأمان ، واستلم الرمز الخاص بك على الفور",
      cr: "إيصال الدفع",
      msg: "تم مكافأتك على شراءك ،  spw تشكرك على ولائك",
      rn: "أعد الشحن مرة أخرى",
      codeRech: "رقم بطاقة الشحن",
      addFav: "أضف إلى قائمة المفضلة",
      gFav: "إدارة أرقامك المفضلة",
      daddFav: "أضف أرقام أحبائك إلى مفضلاتك لتعبئة رصيد أسرع",
      td: "تحويل مباشر",
      vcr: "رمز إعادة الشحن الخاص بك",
      v: "قيمة",
      adfav: "إضافة رقم مفضل",
      imgfav: "الصورة المفضلة",
      add: "أضف",
      edfav: "تعديل الرقم المفضل",
      num8: "الرقم يتكون من 8 أرقام",
      numTel: "رقم الهاتف",
    },
    Marchand: {
      DES1: "ادفع مع التجار الشركاء بأمان عبر حساب spw الخاص بك واستفد من المكافآت والعروض الترويجية. اكتشف قائمة أفضل التجار الذين يقبلون spw كوسيلة للدفع ",
      DES2: "اكتشف قائمة أفضل التجار الذين يقبلون spw كوسيلة دفع",
      DES3: "انطلاق ! دفع آمن ومكافأ لدى شركاء spw",
      DES4: "تسوق وادفع بأمان.",
      DES5: "تحتاج مساعدة؟ لا تتردد في الاتصال بقسم الدعم لدينا",
      dcc: "على مواقع التجار شركائنا ، بمجرد أن تطلب سلعة أو خدمة عن طريق اختيار متابعة الدفع مع spw. يتم إنشاء رمز الدفع عبر الإنترنت لتحديد طلبك ، وهذا هو رمز الطلب",
      T1: "دفع التاجر",
      DT1: "أدخل رمز الطلب",
      T4: "نتيجة العملية",
      DT4: "عرض نتيجة الشراء",
      Contenu1: "رمز الطلب",
      Contenu2: "الدفع عبر رمز الطلب",
      BS: "التالي",
      BV: "التحقق",
      BR: "رجوع",
      ChampOb: "Champ obligatoire",
      Contenu3: "هذا الرمز صالح فقط",
      Contenu4: "دقيقة",
      Contenu5: "معلومات العملية",
      Contenu6: "اسم التاجر",
      Contenu7: "موقع تاجر ",
      Contenu8: "المبلغ",
      Contenu9: "المكافآت",
      Contenu10: "تاريخ العملية",
      DEXP: "تاريخ الانتهاء",
      PNV: "الدفع عن طريق بطاقة جديدة",
      POSTEinfo1: "E-Dinar Smart, Digicard",
      POSTEDinfo1: "Utilisez votre carte prépayée de la Poste",
      POSTEinfo2: "Visa Electron, DinarPost",
      POSTEDinfo2: "Utilisez votre carte Visa Electron ou DinarPost de la poste",
      invFormat: "Format incorrect!",
      DES6: "هدية واحدة ، حياة واحدة! افتح قلبك لجمعية من خلال التبرع لها عبر الإنترنت مع spw ، فقط اضغط على الجمعية واتبع التعليمات. ",
      DES7: "بدون موقع للتجارة الإلكترونية ، ادفع في المتاجر الفعلية أو الافتراضية ، على الشبكات الاجتماعية ، العاملين لحسابهم الخاص ، إلخ. مع رمز التاجر ، معرف التاجر على منصة spw ",
      dT1: "تبرع",
      dDT1: "اختر ارتباطًا",
      dT4: "نتيجة العملية",
      dDT4: "عرض نتيجة الشراء",
      dContenu1: "تبرع",
      dContenu2: "اختر جمعية",
      cmT1: "دفع التاجر",
      cmDT1: "أدخل رمز التاجر",
      cmT4: "نتيجة العملية",
      cmDT4: "عرض نتيجة الشراء",
      cmContenu1: "دفع التاجر",
      cmContenu2: "أدخل رمز التاجر",
      rsite: "العودة إلى موقع التاجر",
      pc: "الدفع عبر رمز التاجر",
      cmd: "اطلب",
      mp: "التجار الشركاء",
    },
    fid: {
      title: "ولاءك يكافِئ ",
      subtitle: "أفضل طريقة لقول شكرا لك! هو برنامج الولاء لدينا",
      subtitle2: "اكسب نقاطًا مع كل عملية شراء ، واجمع النقاط واحصل على مكافآت",
      d1: "انتقل من حالة إلى أخرى واكسب المزيد",
      d2: "استمتع مع spw بمكافأة على مشترياتك",
      pd: "مزيد من التفاصيل حول برنامج الولاء",
      sValide: "الوضع مفعل",
      sActuel: "الوضع الحالي",
      sSuivant: "الوضع التالي",
      sVerouille: "الوضع مغلق",
      fid7: "أفضل طريقة لقول شكرا لك! هو ملاحظة برنامج الولاء",
      fid8: "لمكافأة ولائك ، تقدم لك spw نقاط ولاء تراكمية على كل عملية شراء ، مما يسمح لك بالتقدم في الحالة وبالتالي تتطور المزايا والمكافآت مع كل فقرة",
      sysProg: "نظام التقدم",
      prog1:
        "نقدم 5 حالات ولاء ، قياسية ، فضية ، ذهبية ، ماسية وكبار الشخصيات ، فيما يلي قواعد الانتقال من حالة إلى أخرى",
      prog2: "لفتح حالة ، كل ما عليك فعله هو جمع عدد من النقاط في فترة زمنية محددة.",
      nbPoints: "عدد النقاط المراد جمعها ",
      intervalleDate: "فاصل التاريخ بالأيام",
      sysCollecte: "نظام جمع النقاط",
      coll1: "بعد عمليات الشراء الخاصة بك ، يمكنك تجميع نقاطك بسرعة باتباع المقياس التالي",
      valUni: "قيمة الوحدة بالدينار التونسي",
      ptsaG: "نقاط للفوز",
      sysRec: "نظام المكافآت",
      sysRec1: "طرق مختلفة لمكافأة ولائك ، طرق مختلفة للتعبير عن الشكر",
      sysRecul: "نظام الارتداد",
      sysRecul1: "يمكنني أن أفقد نقاطي بالرغم من  وضعي! للأسف هذا ممكن. ابق مخلصًا ولن تخسر شيئًا.",
    },
    mdp: {
      cr: "بطاقة شحن",
      sc: "اختر بطاقة",
      mdp: "طريقة الدفع",
      cp: "التأكيد والدفع",
      cap: "تأكيد الشراء والدفع",
      ro: "نتيجة العملية",
      vro: "عرض نتيجة الشراء",
      op: "عملية",
      tvcb: "تحويل إلى حساب بنكي",
      Conf: "تأكيد",
      r: "النتيجة",
      ra: "نتيجة الشراء",
    },
    recu: {
      srv: "خدمة",
      scr: "شحن الهاتف عن طريق البطاقة",
      ds: "تفاصيل الخدمة",
      op: "المشغل",
      md: "المبلغ المطلوب",
      com: "عمولة",
      bonus: "المكافآت",
      pf: "نقاط الولاء",
      tap: "المجموع للدفع",
      rem: "تخفيض",
      nm: "اسم التاجر",
      sm: "موقع تاجر ",
      p: "نقطة",
      map: "المبلغ الواجب دفعه",
      ns: "رقم التسلسل",
      dt: "تفاصيل المعاملة",
      tsw: "تحويل الرصيد إلى المحفظة",
      mexp: "البريد الإلكتروني للمرسل",
      mrec: "البريد الإلكتروني للمتلقي",
      dp: "تاريخ الدفع",
      numCpt: "رقم الحساب",
      portC: "صاحب الحساب",
      fraisInt: "الرسوم الدولية",
      nomP: "اسم الشريك",
      codeP: "رمز الدفع",
      numCarte: "رقم البطاقة",
      refPaie: "إشارة دفع",
      idwBene: "معرف محفظة المستفيد",
      numR: "الرقم المشحون",
    },
    faq: {
      title: "نحن هنا لمساعدتك!",
      subtitle: "اختيار فئة سيساعدك على العثور على الإجابات بسرعة وسهولة",
      search: "بحث",
      aucres: "لم يتم العثور على نتائج",
      title2: "هل لديك مزيد من الأسئلة؟",
      subtitle2: "لا تتردد في الاتصال بنا إذا كان لديك أي أسئلة. نحن سعداء دائمًا بمساعدتك",
      box1: "الاتصال بخدمة العملاء",
      box2: "الهاتف",
      box3: "البريد الإلكتروني",
      box4: "العنوان",
      box5: "ساعات العمل",
      resoc: "شبكاتنا الاجتماعية",
      j1: "من الاثنين إلى الجمعة",
      j2: "السبت",
    },
    conso: {
      title: "استهلاك",
      display: "عرض",
      cw: "دخول الأموال إلى المحفظة",
      ea: "توسيع الكل",
      ca: "Collapse All",
      caw: "خروج الأموال من المحفظة",
      ssf: "خدمات spw",
      pdc: "لا يوجد استهلاك خلال هذه الفترة",
      totalRc: "إجمالي عمليات شحن المحفظة",
      totalTr: "إجمالي عمليات تحويل الأموال من المحفظة",
      totalSer: "إجمالي الخدمات المشتراة من سوق SPW",
      dont: "منها",
    },
    DocCarteRech: {
      cr1: " تعبئة الهاتف ببطاقة شحن",
      cr2: "استفد من إحدى خدماتك اليومية ببضع نقرات ، حيث يتم تقديم المكافآت ونقاط الولاء مع كل عملية شراء",
      cr3: "اتبع الخطوات أدناه لشراء رمز زيادة الرصيد",
      cr4: "اختر المشغل وقيمة رمز إعادة الشحن الخاص بك",
      cr5: "اختر طريقة الدفع التي تناسبك وتحقق من صحتها",
      cr6: "تتلقى رمز إعادة الشحن فور الدفع على صفحة النتائج",
      cr7: "انقر رمز إعادة الشحن واستخدم الرمز الذي تلقيته لتعبئة رصيدك",
      cr8: "طريقة إعادة تحميل الكود على جوالك",
      cr9: "* 101 * رمز الشحن #",
      cr10: "* 100 * رمز الشحن #",
      cr11: "* 123 * رمز الشحن #",
      infoService: "معلومات حول  الخدمة",
      fiscal: "تمثل زيادة سعر بطاقة إعادة الشحن رسوم الطابع الضريبي التي يفرضها القانون التونسي",
      crPerdu:
        "إذا فقدت رمز إعادة الشحن الخاص بك أو لم يتم عرض صفحة الدفع ، يمكنك عرض تذكرتك في سجل المعاملات ضمن معاملاتي",
    },
    DocRechTel: {
      td1: "شحن الهاتف بتحويل مباشر",
      td2: "استفد من إحدى خدماتك اليومية ببضع نقرات ، حيث يتم تقديم المكافآت ونقاط الولاء مع كل عملية شراء.",
      td3: "اتبع الخطوات أدناه لشحن رصيدك",
      td4: "أدخل رقم الهاتف ومبلغ إعادة الشحن",
      td5: "اختر طريقة الدفع التي تناسبك وتحقق من صحتها.",
      td6: "سيتم تحويل المبلغ الذي طلبته إلى خط الهاتف الخاص بك فور الدفع",
      td7: "النسبة لـ Ooredoo Light ، تقوم TTcash و Orange Express بإعادة شحن قيمة الطابع الضريبي وسيتم خصمها من مبلغ إعادة الشحن (14٪)  ",
      td8: "سيتم إرسال رسالة نصية قصيرة من قبل المشغل إلى المستفيد لتأكيد نجاح عملية الشحن",
    },
    DocEspece: {
      cashInEspHeader: "شحن  محفظة spw نقدًا عن طريق الدفع / التحويل",
      cashInEsp1:
        "من خلال الإيداع / التحويل ، يمكنك زيادة رصيدك spw وإجراء العديد من معاملات الشراء دون المرور عن طريق الدفع عن طريق البطاقة المصرفية أو البطاقة البريدية المدفوعة مسبقًا",
      cashInEsp2: "اتبع الخطوات أدناه لشحن محفظتك عن طريق الإيداع / التحويل",
      cashInEsp3: "خد موعد في  أحد فروع البنك أو مكتب البريد ",
      cashInEsp4: "قم بإيداع المبلغ الذي تريد استخدامه على spw في حساب شركة همتال",
      cashInEsp5: "بعد الإيداع ، ستجد رقم القسط المعروض على الإيصال.",
      cashInEsp6: "انتقل إلى قسم شحن المحفظة النقدية على SPW.tn وأكمل نموذج",
      cashInEsp7:
        "بعد التحقق من صحة طلبك من قبل مسؤولينا ، سيتم قيد حسابك spw بعد وقت قصير بالمبلغ الذي طلبته.",
    },
    DocWallet: {
      interw1:
        "يمكنك إرسال (أو استلام) الأموال إلى (أو من) محفظة أحد أفراد أسرتك على الفور وبشكل آمن وبدون تكلفة إضافية. يجب أن يكون المستلم مسجلاً على SPW.tn للاستفادة من هذه الخدمة     ",
      interw2: "اتبع الخطوات أدناه لشحن محفظة أخرى على spw ",
      interw3: "أدخل معرف المحفظة أو البريد الإلكتروني الخاص بالمستلم والمبلغ المراد تحويله",
      interw4: "اترك رسالة لمتلقيك! إذا أردت",
      interw5: "تحقق من صحة العملية ويتم تمويل محفظة المستلم على الفور",
      interw6:
        "نصيحة مع spw لتبسيط التنقل! لا حاجة للبحث عن البريد الإلكتروني للمستفيد أو معرف المحفظة مع كل عملية تحويل ، لذا أضف محافظ أحبائك كمفضلة",
    },
    en: {
      title: "إنجليزية",
    },
    fr: {
      title: "فرنسية",
    },
    ar: {
      title: "العربية",
    },
    da: {
      title: "الدارجة",
    },
    trans: {
      title: "معاملاتي",
      search: "بحث المعاملات",
      idt: "رقم المعاملة",
      det: "تفاصيل",
      auctran: "لم يتم العثور على أي معاملات",
    },
    supp: {
      title: "هل ترغب في إغلاق هذه التذكرة؟",
      txt: "إذا قمت بتأكيد هذه العملية، فسيتم إغلاق التذكرة نهائيًا",
      btn1: "نعم أؤكد",
      btn2: "يلغي",
      nt: "تذكرة جديدة",
      t: "التذاكر",
      tn: "تذكرة رقم",
      not: "لم يتم إنشاء أي تذاكر",
      mr: "الشكاوي",
      vm: "رسالتك",
      af: "إضافة ملف",
      fr: "إغلاق الشكوى",
    },
    marchext: {
      title: "أدخل معلوماتك لتتبع الدفع",
      it: "معلومات العملية",
      dt: "تاريخ العملية",
      bsf: "مكافآت spw",
      adv: "ما هي مميزات الدفع مع spw؟",
      paysf: "لماذا تدفع عن طريق حساب spw",
      db: "لمكافآت",
      sr: "نظام الاسترداد",
      sd: "دعم مخصص",
      mvf: "شكرا لك على ولائك",
      vcc: "رمز الطلب الخاص بك",
      att: "يرجى ملاحظة أن الرمز صالح فقط",
      prg: "يمكنك استخدام رمز الطلب لإنهاء إجراء الدفع أو إعطاء الرمز لشخص قريب منك لإجراء الدفع نيابةً عنك",
      pexp: "الدفع السريع",
      sp: "تم الدفع بنجاح",
      inscsf: "قم بالتسجيل في spw",
      cn: "الاتصال",
      p1: "لقد تم الدفع بنجاح للتاجر",
      rec: "يرجى العثور على إيصالك أدناه",
      fq: "اجعل حياتك اليومية أسهل مع spw",
      rt: "إعادة تعبئة الهاتف",
      ta: "تحويل الأموال",
      dsf: "اكتشف spw",
      sc: "خدمة الزبائن",
    },
    bloc: {
      title: "طلب إثبات",
      dtitle: "تم حظر حسابك spw مؤقتًا",
      d1: "الوجه الأمامي البطاقة التعريف",
      d2: "منظر أمامي لبطاقة الهوية",
      cimg: "اختر صورة",
      d3: "بطاقة الهوية أو جواز السفر مع وجهك",
      d4: "بطاقة الهوية أو جواز السفر مع وجهك",
      d5: "كشف حساب بنكي",
      d6: "البطاقة البنكية منظر أمامي",
      title2: "التحقق عبر الهاتف",
      dtitle2: "الرجاء إدخال رمز التحقق الذي تلقيته عبر الرسائل القصيرة",
      sno: "خدمة غير مصرح بها",
      dsno: "قم بتأكيد حسابك للاستفادة من هذه الخدمة",
      dsno2: "قم بتأكيد حسابك عبر صفحتك الرئيسية للاستفادة من هذه الخدمة",
    },
    qt: {
      title: "تحويل الأموال إلى محفظة spw أخرى",
      p1: "أنت على وشك تحويل",
      p2: "من محفظتك إلى محفظة ",
      id: "هوية",
      p3: "بمجرد التأكيد، سيتم خصم المبلغ مباشرة من محفظة SPW الخاصة بك",
      vt: "أكد التحويل",
      p4: "التحويل من ",
      p5: "تم إرسالها بنجاح إلى محفظة المستفيد",
    },
    cloture: {
      title: "قم بإغلاق حسابك spw واحذف بياناتك",
      p1: "إذا كنت بحاجة إلى مساعدة قبل إغلاق حسابك spw بشكل دائم، يرجى الاتصال بنا من خلال الرابط التالي",
      nc: "اتصل بنا",
      p2: "بمجرد إغلاق هذا الحساب، سيتم حذف جميع بياناتك. لن تتمكن من استخدامه أو إعادة فتحه، ولكن يمكنك التسجيل مرة أخرى لفتح حساب آخر",
      rc: "سبب الإغلاق",
      min8: "الحد الأدنى 8 أحرف",
      cc: "إغلاق الحساب",
      q: "هل تريد حقاً إغلاق حسابك spw نهائياً؟",
    },
    gcb: {
      nocarte: "لم يتم حفظ أي بطاقة",
      title: "يجب عليك تسجيل البطاقة عند الدفع ببطاقة مصرفية",
      ac: "تفعيل البطاقة",
      dc: "إلغاء البطاقة",
      sc: "حذف البطاقة",
    },
    popst: {
      title: "تهانينا!",
      title2: "حالة الولاء الجديدة",
      title3: "spw تقدم لك نقاط هدية",
      title4: "شكرا لك على ولائك",
    },
    tw: {
      tw: "تحويل الأموال إلى محفظة spw",
      tnv: "حول مرة أخرى",
      mpin: "تغيير رقم التعريف الشخصي",
      confpin: "قم بتأكيد المعاملة باستخدام رقم التعريف الشخصي (PIN) الخاص بك",
    },
    docBank: {
      title: "حوالة مصرفية",
      d1: "مع خدمة التحويل البنكي يمكنك طلب تحويل رصيدك على منصة spw إلى حسابك البنكي المعتمد",
      d2: "ما هو الحساب البنكي المثبت؟",
      d3: "وهو حساب بنكي يستوفي الشروط التالية:",
      d4: "يجب أن يحمل الحساب البنكي نفس اسم حساب spw الخاص بك وإلا سيتم رفض طلبك",
      d5: "قبل التحقق من صحة تحويلك الأول، يجب عليك أن ترسل إلينا ملف معرف البنك الخاص بك أو كشف الحساب البنكي الذي يحتوي على RIB واضح وقابل للقراءة.",
      d6: 'من تهمه خدمة "التحويل إلى الحساب البنكي"؟',
      d7: "جميع المستخدمين الذين تم التحقق منهم على منصة SPW",
      d8: "إضافة حساب",
      d9: 'انقر على الزر "+".',
      d10: "أكمل نموذج الإضافة",
      d11: "قم بتنزيل ملف معرف البنك الخاص بك أو كشف الحساب البنكي.",
      d12: "انقر على التحقق لإرسال طلب الإضافة الخاص بك.",
      d13: "كيفية التحويل إلى حساب بنكي؟",
      d14: 'يمكن لجميع المسجلين المعتمدين على spw، من قسم "التحويل البنكي"، إجراء تحويل رصيد من حساب spw الخاص بهم إلى حسابهم البنكي. كل ما عليك القيام به هو إتباع الخطوات أدناه:',
      d15: "أدخل المبلغ المراد تحويله بالـ دت (الحد الأدنى 20 دت والحد الأقصى 3000 دت)",
      d16: "أدخل RIB (سلسلة مكونة من 20 رقمًا).",
      d17: "اختر البنك الذي يتوافق مع RIB.",
      d18: 'قم بتأكيد التحويل بالضغط على "إرسال".',
      d19: "يستغرق الأمر بضعة أيام لمعالجة طلبك",
      d20: "يمكنك إجراء تحويل مصرفي فقط إذا كان رصيد spw الخاص بك أكبر أو يساوي من المبلغ المطلوب دفعه (المبلغ مع العمولة).",
      d21: "إذا كان لديك طلب تحويل مصرفي قيد التقدم، فلا يمكنك إرسال طلب تحويل آخر.",
      d22: "كم يكلفني؟",
      d23: "العمولة المطبقة على هذه الخدمة هي 2 د.ت",
      d24: "مميزات التحويل البنكي عبر الإنترنت على spw:",
      d25: "اسحب رصيد spw الخاص بك من فرعك أو بطاقتك المصرفية",
      d26: "استفد من التحويل الآمن والفوري عبر الإنترنت الذي يمكن الوصول إليه في أي وقت (24/24 و7/7)",
    },
    docM: {
      title: "دفع التاجر",
      d1: "ما هو الدفع للتاجر؟",
      d2: "خدمة الدفع عبر الإنترنت هي مجموعة من العمليات غير المادية المتاحة لمستخدمي spw.tn، مما يسمح لهم بدفع ثمن المشتريات التي تتم على موقع التجارة الإلكترونية الشريك لـ SPW. يتم هذا الدفع عبر حساب spw بطريقة آمنة.",
      d3: "طريقة الخدمة",
      d4: "بعد التحقق من صحة سلتك على موقع التاجر واختيار طريقة الدفع من قبل spw، يمكنك الدفع باستخدام الطريقتين أدناه:",
      d41: "الطريقة الأولى:",
      d5: "ستقوم بملء النموذج عن طريق إدخال معلومات مثل البريد الإلكتروني أو كلمة المرور أو رقم الهاتف المرتبط بحساب spw الخاص بك. سيتم بعد ذلك إعادة توجيهك إلى نموذج التحقق من الدفع لاختيار الطريقة التي ترغب في الدفع بها: بطاقة مصرفية وطنية أو دولية، بطاقة e-DINAR من مكتب البريد أو عن طريق رصيد spw الخاص بك.",
      d42: "الطريقة الثانية:",
      d6: "يتم تحديد كل معاملة دفع للتاجر من خلال رمز الدفع ويتم تحديد كل تاجر من خلال رمز التاجر الذي يمكنك استخدامه عند التحقق من صحة الدفع عن طريق الوصول إلى حساب spw الخاص بك ضمن قسم دفع التاجر.",
      d7: "بمجرد التحقق من صحة الدفع، لم يعد بإمكانك إلغاء المعاملة.",
      d8: "يتم التحقق من صحة دفع التاجر على الفور ويتم تفعيل عملية التسليم على الفور.",
      d9: 'إذا فقدت رمز الدفع، فيمكنك استعادته من سجل معاملات "دفع التاجر".',
      d10: "يظل رمز الدفع صالحًا لمدة 60 دقيقة فقط. بعد هذه الفترة، لن يتمكن المستخدم من الدفع باستخدام هذا الرمز ويجب عليه تقديم طلب آخر على موقع التاجر.",
      d43: "تنفيذ الدفع:",
      d11: "المبالغ الواجب دفعها المذكورة على موقع التاجر مبينة بالدينار التونسي (د.ت) شاملة جميع الضرائب، وهي صالحة في وقت مشاهدتها من قبل العميل. سيتم أخذ الدفع بعين الاعتبار على الفور من قبل النظام. إذا لم يكن هذا الأخير متاحًا، فسيتم إبلاغك ولن يتم أخذ دفعتك في الاعتبار. يمكنك استئناف الدفع لاحقًا",
      d44: "الدفع :",
      d12: "لإجراء الدفع، سوف تحتاج إلى اختيار spw كطريقة الدفع الخاصة بك عن طريق النقر على الزر المقدم لهذا الغرض. تتم إدارة دفعتك عن طريق خدمة spw بواسطة شركة HAMTEL التي تقدم خدمة دفع آمنة تمامًا. أنت تضمن لـ spw أن لديك التفويضات التي قد تكون ضرورية لاستخدام طريقة الدفع المختارة، عند التحقق من صحة طلب الدفع الخاص بك. ولتحقيق هذه الغاية، فإنك تعلن أنك المالك الشرعي لحساب spw المستخدم للدفع عبر الإنترنت وأنك تتحمل جميع العواقب بخلاف ذلك.",
      d13: "حماية وحقوق المستخدم:",
      d14: "أجل التسليم :",
      d15: "يجب على البائع أو موقع التاجر تسليم البضائع أو أداء الخدمة لك في التاريخ المحدد عند الطلب. إذا لم يتم تحديد تاريخ عند الطلب، فيجب أن يتم تسليم البضائع أو أداء الخدمة في موعد لا يتجاوز شهر واحد بعد الطلب.",
      d16: "إذا لم يتم استيفاء وقت التسليم، يمكنك إلغاء طلبك عن طريق إرسال طلب من حساب spw الخاص بك.",
      d17: "الموعد النهائي للسداد:",
      d18: "إذا قمت بإرجاع البضائع إلى التاجر الشريك spw أو قمت بإلغاء الخدمة بعد إلغاء طلبك بسبب عدم الالتزام بوقت التسليم أو إذا كان المنتج الذي اشتريته من موقع التاجر يظهر عدم المطابقة بعد التسليم:",
      d19: "إنه غير صالح للاستخدام المتوقع عادةً من سلعة مماثلة..",
      d20: "لا يتطابق مع الوصف الذي قدمه البائع (على سبيل المثال، اللون لا يتطابق مع النموذج المعروض).",
      d21: "لا يتمتع بالصفات التي أعلن عنها البائع (على سبيل المثال، جهاز تم تقديمه على أنه هادئ بشكل خاص ثم تبين أنه صاخب).",
      d22: "يجب أن يتم تعويضك خلال شهر واحد كحد أقصى. ومع ذلك، يجوز للتاجر تأجيل السداد حتى يوم جمع البضائع أو حتى تقدم دليلاً على شحن البضائع.",
      d23: "يجب على التاجر أن يعوضك بالكامل عن المبالغ التي دفعتها، بما في ذلك تكاليف التوصيل.",
      d24: "إذا لم يتم استيفاء وقت التسليم، يمكنك إلغاء طلبك عن طريق إرسال طلب من حساب spw الخاص بك.",
      d25: "استحقاق المكافأة:",
      d26: "سيحصل كل مستخدم على مكافأة على المشتريات التي تتم من التجار الشركاء spw. هذه هي النسبة التي يتم خصمها من مبلغ معاملة الشراء وإضافتها إلى رصيد المكافأة الخاص بالمستخدم:",
      d27: "المكافأة الممنوحة للمشتري ليست ثابتة وتعتمد على التاجر أو الخدمة الموجودة على spw وسيتم عرضها قبل تنفيذ كل دفعة.",
      d28: "يمكن للتاجر الشريك spw أن لا يمنح مكافآت للمشترين مقابل بعض أو كل العناصر أو الخدمات المقدمة في متجره.",
      d29: "إن التحقق من الدفع من قبل المستخدم يعني قبول السعر والمكافأة المتعلقة بالسلعة أو الخدمة المقدمة من قبل التاجر أو spw.",
      d30: "يمكن لعميل spw استخدام المكافأة وتحويله إلى رصيد spw فقط إذا تجاوز رصيد المكافأة 5 دنانير (خمسة دنانير تونسية).",
      d31: "يمكنك فقط تحويل رصيد المكافأة الخاص بك إلى رصيد spw الخاص بك.",
      d32: "إذا تم إلغاء الدفع أو تم استرداد أموال العميل، فسيتم خصم مبلغ المكافأة المتعلق بالمعاملة الملغاة من رصيد المكافأة الخاص بالعميل.",
      d33: "إذا كان رصيد المكافأة أقل من مبلغ المكافأة المتعلق بالمعاملة الملغاة، فسيتم خصم هذا الأخير من المبلغ الإجمالي أو الجزئي للمعاملة الملغاة قبل تعويض العميل.",
      d34: "مميزات الدفع للتاجر عن طريق spw:",
      d35: "يمكنك الدفع لأي شريك تجاري (فعلي أو افتراضي) لspw.",
      d36: "تحصل دائمًا على مكافأة بعد كل دفعة للتاجر.",
      d37: "خدمة آمنة للغاية وفورية",
      d38: "استرداد فوري في حالة وجود مشكلة.",
      d39: "تحمي spw مستخدميها من مشاكل الاحتيال أو عدم الالتزام بمواعيد التسليم لجميع المدفوعات عبر الإنترنت التي تتم باستخدام حسابات spw الخاصة بهم.",
      d40: "حل سهل الاستخدام يمكن الوصول إليه في أي وقت (24/24 و7/7)",
    },
    pays: {
      Ariana: "اريانة",
      Beja: "باجة",
      BenArous: "بن عروس",
      Bizerte: "بنزرت",
      Gabes: "قابس",
      Gafsa: "قفصة",
      Jendouba: "جندوبة",
      Kairouan: "القيروان",
      Kasserine: "القصرين",
      Kebili: "قبلي",
      Kef: "الكاف",
      Mahdia: "المهدية",
      Manouba: "منوبة",
      Medenine: "مدنين",
      Monastir: "المنستير",
      Nabeul: "نابل",
      Sfax: "صفاقس",
      SidiBouzid: "سيدي بوزيد",
      Siliana: "سليانة",
      Sousse: "سوسة",
      Tataouine: "تطاوين",
      Tozeur: "توزر",
      Tunis: "تونس",
      Zaghouan: "زغوان",
      Autre: "أخرى",
      tt: "كل المدن",
      t: "الكل",
    },
    listserv: {
      title: "الخدمات المقدمة من قبل متجر",
      t2: "",
      des: "للشراء، انقر على الخدمة المرغوبة واتبع عملية الشراء عن طريق وسيلة الدفع spw",
    },
  },
};
